/* INTERACTIVE v2 (2026-07-19, MOBILE-FIRST) — NINCS hover. Csak scroll/tap-vezérelt,
   LÁTHATÓ effektek. Kikapcsol prefers-reduced-motion alatt (a tartalom-váltás marad). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1) SCROLL-REVEAL fallback: ahol nincs natív scroll-timeline (Firefox), IntersectionObserver
     rakja fel a .i-in-t. (A natív .i-rise CSS a támogató böngészőkben magától megy.) */
  if ('IntersectionObserver' in window && !reduce) {
    var supportsView = CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    if (!supportsView) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { en.target.style.opacity = '1'; en.target.style.transform = 'none'; en.target.style.transition = 'opacity .5s cubic-bezier(.16,1,.3,1), transform .5s cubic-bezier(.16,1,.3,1)'; io.unobserve(en.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.i-rise').forEach(function (el) { el.style.opacity = '0'; el.style.transform = 'translateY(26px)'; io.observe(el); });
    }
  }

  /* 2) ADD-TO-CART SIKER — a kosár-szám növekedésére LÁTHATÓ pulse a kosár-ikonon.
     Robusztus, téma-független (MutationObserver a count-bubble-on), nem zavarja a flow-t. */
  if (!reduce) {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble, .cart-count-bubble, #cart-icon-bubble');
    var icon = document.querySelector('#cart-icon-bubble') || bubble;
    if (bubble && icon && icon.animate) {
      var last = (bubble.textContent || '').replace(/\D/g, '');
      var mo = new MutationObserver(function () {
        var now = (bubble.textContent || '').replace(/\D/g, '');
        if (now && now !== last && (parseInt(now, 10) || 0) > (parseInt(last, 10) || 0)) {
          icon.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.3)' }, { transform: 'scale(1)' }],
            { duration: 440, easing: 'cubic-bezier(.16,1,.3,1)' });
        }
        last = now;
      });
      mo.observe(bubble, { childList: true, characterData: true, subtree: true });
    }
  }
})();
